import React, { useState, useRef, useCallback, useEffect } from 'react';
import ReactToPrint from 'react-to-print';
import { Container, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { toast } from 'react-hot-toast';
import PrintNewOrderComponent from '~/components/PrintNewOrderComponent';
import EyeModalOrders from '~/components/EyeModalOrders';
import DeleteItemOrders from '~/components/Orders/DeleteItemOrders';
import api2 from '~/services/api2';

import { useAuth } from '~/context/AuthContext';

import { addMessageWhatsapp } from '~/utils/handleNotifyWhatsapp';
import { FaEye, FaPrint } from 'react-icons/fa';
import TableEditDelivery from '~/components/Operation/TablesOperation/TableEditDelivery';
import PreparationTime from '~/components/Delivery/PreparationTime';
import {
  Actions,
  ButtonCancel,
  CardContainer,
  DisplayNoneImprimir,
  CardBody,
  DeliveryInfo,
  DeliveryTime,
  NameClient,
  PhoneClient,
  InfoClientDelivery,
} from './styles';
import { PhoneNumber, UserDeliveryInfo, UserDeliveryInfoArea } from '../styles';
import { DeliveryCardHeader } from '../DeliveryCardHeader';
import { FaPlus } from 'react-icons/fa6';
import { fetchDataToPrint } from '~/services/printer/dataToPrint';
import { printHtmlInIframe } from '~/services/printer/printerUtils';
import { format } from 'date-fns';
import { Button as ButtonUI, IconClipboardCheck } from 'takeat-design-system-ui-kit';
import { Button } from 'ui-kit-takeat';

export default function OrderNewDelivery({
  item,
  handlePrintItem,
  handleCancelItem,
  handleUpdate,
}) {
  const { user } = useAuth();
  const componentRef = useRef(null);
  const [modal, setModal] = useState(false);
  const [btnDisable, serBtnDisable] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ordersNotGrouped, setOrdersNotGrouped] = useState([]);
  const [loadingCancelItem, setLoadingCancelItem] = useState(false);

  const getOrders = useCallback(async () => {
    try {
      const response = await api2.get(
        `/restaurants/basket-orders/${item.basket.id}`
      );
      setOrders(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [item]);

  const [reqPrint, setReqPrint] = useState(false);

  const iframeRef = useRef(null);
  const handleFetchDataToPrint = async (payload) => {
    try {
      const htmlResponse = await fetchDataToPrint(payload);
      printHtmlInIframe(iframeRef, htmlResponse);
    } catch (error) {
      console.log('error em imprimir no delivery', error);
      toast.error('Erro ao buscar dados para impressão');
    }
  };

  const getOrdersAndNotify = useCallback(async () => {
    try {
      // essa request é feita pra atualizar as orders quer irão ser enviadas
      // para o whatsapp
      const response = await api2.get(
        `/restaurants/basket-orders/${item.basket.id}`
      );

      const orders = response.data;

      addMessageWhatsapp({
        item,
        orders,
        user,
        status: 'accepted',
      });
    } catch (error) {
      console.log(error);
    }
  }, [item]);

  const getOrdersNotGrouped = useCallback(async () => {
    try {
      const response = await api2.get(
        `/restaurants/basket-orders/${item.basket.id}?group=false`
      );

      setOrdersNotGrouped(response.data);
    } catch (error) {
      console.log(error);
    }
  }, [item]);

  const toggle = () => setModal(!modal);

  const [modalDelete, setModalDelete] = useState(false);
  const toggleDelete = () => {
    setModalDelete(!modalDelete);
    serBtnDisable(!btnDisable);
  };

  const [modalDeleteDelivery, setModalDeleteDelivery] = useState(false);
  const toggleDeleteDelivery = () => {
    setModalDeleteDelivery(!modalDeleteDelivery);
    serBtnDisable(!btnDisable);
  };

  const userNameDelivery = item?.buyer
    ? item.buyer.phone
      ? item.buyer.phone
      : item.buyer.ifood_phone
      ? item.buyer.ifood_phone
      : item.buyer.neemo_phone || ''
    : item?.waiter?.name;

  async function closeClick() {
    if (reqPrint) return;
    setReqPrint(true);

    try {
      if (user.print_bills_delivery_on_web) {
        await api2.post('restaurants/printers/printer-queue', {
          order_basket_id: item.basket.id,
          order_type: 'new_order',
        });
      }

      await handlePrintItem(
        item.basket.id,
        item.basket.ifood_id,
        item?.table?.table_type === 'delivery'
      );

      if (!item.basket.ifood_id) {
        await getOrdersAndNotify();
      }
    } catch (error) {
      toast.error('Erro ao aceitar pedido.');
    } finally {
      setReqPrint(false);
    }
  }

  useEffect(() => {
    if (modalDelete) {
      getOrdersNotGrouped();
    }
  }, [getOrdersNotGrouped, modalDelete, modal]);

  // useEffect(() => {
  //   if (!user?.is_printed_on_web) {
  //     getOrders();
  //   }
  // }, [getOrders, user.is_printed_on_web]);

  const [preparingTimeBasket, setPreparingTimeBasket] = useState('0h:0m');
  const [stepTime, setStepTime] = useState('0h:0m');

  useEffect(() => {
    const calcularDiferencaHorasMinutos = (dataInicio) => {
      const startDate = new Date(
        new Date(dataInicio).toLocaleString('en-US', {
          timeZone: 'America/Sao_Paulo',
        })
      );
      const diffMs = Date.now() - startDate.getTime();

      if (diffMs < 0) return '0h:0m'; // Evita valores negativos

      const horas = Math.floor(diffMs / (1000 * 60 * 60));
      const minutos = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      return `${horas}h:${minutos}m`;
    };

    if (item?.basket?.start_time) {
      // Atualiza imediatamente ao renderizar
      setStepTime(calcularDiferencaHorasMinutos(item.basket.start_time));
      setPreparingTimeBasket(
        calcularDiferencaHorasMinutos(item.basket.start_time)
      );

      // Descobre quantos milissegundos faltam para o próximo minuto exato
      const now = new Date();
      const msAteProximoMinuto = (60 - now.getSeconds()) * 1000;

      // Atualiza exatamente na virada do minuto
      const timeout = setTimeout(() => {
        setStepTime(calcularDiferencaHorasMinutos(item.basket.start_time));
        setPreparingTimeBasket(
          calcularDiferencaHorasMinutos(item.basket.start_time)
        );

        // Depois do primeiro ajuste, inicia o intervalo de 1 minuto
        const interval = setInterval(() => {
          setStepTime(calcularDiferencaHorasMinutos(item.basket.start_time));
          setPreparingTimeBasket(
            calcularDiferencaHorasMinutos(item.basket.start_time)
          );
        }, 60000);

        return () => clearInterval(interval);
      }, msAteProximoMinuto);

      return () => clearTimeout(timeout);
    }
  }, [item]);

  return (
    <CardContainer>
      <iframe ref={iframeRef} style={{ display: 'none' }} />
      <DeliveryCardHeader item={item} />

      {!item.scheduled_to && (
        <PreparationTime
          kanbanType={item?.basket?.order_status}
          preparingTime={preparingTimeBasket}
          stepTime={stepTime}
        />
      )}

      <CardBody>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 6,
          }}
        >
          {item?.buyer?.name && <NameClient>{item.buyer.name}{item?.buyer?.has_observation && <span title="Há uma observação sobre este cliente" style={{ marginLeft: 4, display: 'inline-flex' }}><IconClipboardCheck fontSize={14} fill="#FFA814" /></span>}</NameClient>}
          {item?.basket?.schedule && (
            <PhoneClient>
              <strong>{item?.basket?.schedule}</strong>
            </PhoneClient>
          )}
          <PhoneClient>{userNameDelivery}</PhoneClient>
          {!item?.with_withdrawal && (
            <UserDeliveryInfoArea>
              {item?.buyer?.delivery_address?.neighborhood && (
                <InfoClientDelivery>
                  Bairro: {item?.buyer?.delivery_address?.neighborhood}-{' '}
                  {item?.buyer?.delivery_address?.city}
                </InfoClientDelivery>
              )}

              {item?.buyer?.delivery_address?.zip_code && (
                <InfoClientDelivery>
                  CEP: {item?.buyer?.delivery_address?.zip_code}
                </InfoClientDelivery>
              )}
            </UserDeliveryInfoArea>
          )}

          {item?.ifood_delivery_time && (
            <DeliveryInfo>
              <span>Previsão de entrega:</span>{' '}
              <DeliveryTime>
                {format(new Date(item.ifood_delivery_time), "HH'h'mm")}
              </DeliveryTime>
            </DeliveryInfo>
          )}
        </div>
        <Actions>
          {user.is_printed_on_web ? (
            <ButtonUI
              variant="text"
              disabled={reqPrint}
              customColor="#3BD2C1"
              style={{ padding: 0, height: 20 }}
              onClick={async () => {
                if (reqPrint) return;

                try {
                  setReqPrint(true);

                  await handleFetchDataToPrint({
                    print_type: 'table_session',
                    table_session_id: item.session_id,
                    is_delivery: true,
                  });

                  await new Promise((resolve) => setTimeout(resolve, 1000));

                  if (!item.basket.ifood_id) {
                    addMessageWhatsapp({
                      item,
                      orders,
                      user,
                      status: 'accepted',
                    });
                  }

                  handlePrintItem(
                    item.basket.id,
                    item.basket.ifood_id,
                    item?.table?.table_type === 'delivery'
                  );
                } finally {
                  setReqPrint(false);
                }
              }}
            >
              <FaPrint size={16} />
            </ButtonUI>
          ) : (
            <>
              {item?.table?.table_type === 'delivery' &&
              user.print_bills_delivery_on_web ? (
                <ButtonUI
                  variant="text"
                  disabled={reqPrint}
                  customColor="#3BD2C1"
                  style={{ padding: 0, height: 20 }}
                  onClick={async () => {
                    if (reqPrint) return;

                    try {
                      setReqPrint(true);

                      await handleFetchDataToPrint({
                        print_type: 'table_session',
                        table_session_id: item.session_id,
                        is_delivery: true,
                      });

                      await new Promise((resolve) => setTimeout(resolve, 1000));

                      if (!item.basket.ifood_id) {
                        addMessageWhatsapp({
                          item,
                          orders,
                          user,
                          status: 'accepted',
                        });
                      }

                      handlePrintItem(
                        item.basket.id,
                        item.basket.ifood_id,
                        item?.table?.table_type === 'delivery'
                      );
                    } finally {
                      setReqPrint(false);
                    }
                  }}
                >
                  <FaPrint size={16} />
                </ButtonUI>
              ) : (
                <ButtonUI
                  variant="text"
                  disabled={reqPrint}
                  customColor="#3BD2C1"
                  style={{ padding: 0, height: 20 }}
                  onClick={closeClick}
                >
                  <FaPrint size={16} />
                </ButtonUI>
              )}
            </>
          )}

          <FaEye color="#FFA814" onClick={toggle} size={20} />

          <TableEditDelivery
            item={item}
            toggleDeleteDelivery={toggleDeleteDelivery}
            handleUpdate={handleUpdate}
          />
        </Actions>
      </CardBody>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalBody>
          <EyeModalOrders item={item} />
        </ModalBody>
      </Modal>

      <DisplayNoneImprimir>
        <PrintNewOrderComponent
          ref={componentRef}
          restaurant={user}
          item={item}
          handlePrintItem={handlePrintItem}
          orders={orders}
        />
      </DisplayNoneImprimir>

      <Modal isOpen={modalDeleteDelivery} toggle={toggleDeleteDelivery}>
        <ModalBody>
          <h3>Tem certeza que deseja recusar o pedido?</h3>
        </ModalBody>
        <ModalFooter>
          <Button
            inverted
            onClick={() => toggleDeleteDelivery()}
            title="Desistir"
          />

          <Button
            onClick={() =>
              handleCancelItem({
                from: 'pending',
                order_basket_id: item.basket.id,
                session_id: item.session_id,
                ifood_id: item.basket.ifood_id,
              })
            }
            title="Recusar o pedido"
          />
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalDelete} toggle={toggleDelete}>
        <ModalBody>
          <Container>
            <DeleteItemOrders
              item={item}
              modalDelete={modalDelete}
              from="pending"
              orders={ordersNotGrouped}
            />
          </Container>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel
            color="danger"
            onClick={async () => {
              setLoadingCancelItem(true);
              await handleCancelItem({
                order_basket_id: item.basket.id,
                from: 'pending',
                ifood_id: item.basket.ifood_id,
              });
              setLoadingCancelItem(false);
            }}
            disabled={loadingCancelItem}
            type="button"
          >
            Cancelar todos de uma vez
          </ButtonCancel>
        </ModalFooter>
      </Modal>
    </CardContainer>
  );
}
